/* eslint-disable max-len,import/prefer-default-export */
import {
    GridFilterOperator,
} from '@mui/x-data-grid-pro'

import {
    FilterType,
} from 'app/enums/common.enums'

import {
    SkyDataGridColumnDefinition,
    FilterOperatorType,
    SkyNetDataGridFilterType,
    SkyBaseDataSourceProvider,
} from '../SkyBaseDataGrid.types'
import ArrayFilterAutocompleteInput, {
    ArrayFilterAutocompleteInputProps,
} from '../components/FilterInputs/ArrayFilterAutocompleteInput'
import BooleanFilterInput from '../components/FilterInputs/BooleanFilterInput'
import BooleanSwitchFilterInput from '../components/FilterInputs/BooleanSwitchFilterInput'
import TimeLessDateRangeSelectorFilterInput from '../components/FilterInputs/TimeLessDateRangeSelectorFilterInput'

const FilterInputMap = {
    [FilterType.Array]: ArrayFilterAutocompleteInput,
    [SkyNetDataGridFilterType.Boolean]: BooleanFilterInput,
    [SkyNetDataGridFilterType.Toggle]: BooleanSwitchFilterInput,
    [SkyNetDataGridFilterType.TimeLessDateRange]: TimeLessDateRangeSelectorFilterInput,
}

export const customEqualsOperator = (dataSource: SkyBaseDataSourceProvider,
    column: SkyDataGridColumnDefinition<any>): GridFilterOperator<any, any, any, ArrayFilterAutocompleteInputProps>[] => {
    return !column.filterType ? [] : [{
        label: 'Equals',
        value: column.hiddenFromColumns ? FilterOperatorType.DataFilter : FilterOperatorType.EqualsIncludeFilter,
        getApplyFilterFn: () => {
            return (value) => {
                return (
                    value !== null
                )
            }
        },
        InputComponent: FilterInputMap[column.filterType],
        InputComponentProps: {
            requestBaseUrl: dataSource?.request?.url,
            requestData: dataSource?.request?.data,
            dataSourceKey: dataSource?.key,
        },
    }]
}
